import React from 'react';
import { useTranslation } from 'react-i18next';
import { useProbeContext } from '@/probe/ProbeContext';
import { toHex } from '@/utils/hex';

const TargetInfoView: React.FC = () => {
  const { t } = useTranslation('webflash');
  const { targetInfo } = useProbeContext();

  if (!targetInfo) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
          {t('target.title')}
        </h3>
        <p className="text-sm text-gray-400">{t('target.unknown')}</p>
      </div>
    );
  }

  const formatSize = (bytes: number): string => {
    if (bytes >= 1024 * 1024) return `${bytes / (1024 * 1024)} MB`;
    return `${bytes / 1024} KB`;
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('target.title')}
      </h3>
      <dl className="grid grid-cols-2 gap-3 text-sm">
        <dt className="text-gray-500 dark:text-gray-400">{t('target.partNumber')}</dt>
        <dd className="font-mono font-medium text-gray-900 dark:text-white">{targetInfo.partNumber}</dd>

        <dt className="text-gray-500 dark:text-gray-400">IDCODE</dt>
        <dd className="font-mono text-gray-900 dark:text-white">{toHex(targetInfo.idcode)}</dd>

        <dt className="text-gray-500 dark:text-gray-400">{t('target.flashSize')}</dt>
        <dd className="text-gray-900 dark:text-white">{formatSize(targetInfo.flashSize)}</dd>

        <dt className="text-gray-500 dark:text-gray-400">{t('target.ramSize')}</dt>
        <dd className="text-gray-900 dark:text-white">{formatSize(targetInfo.ramSize)}</dd>

        <dt className="text-gray-500 dark:text-gray-400">{t('target.cpuType')}</dt>
        <dd className="text-gray-900 dark:text-white">{targetInfo.cpuType}</dd>

        <dt className="text-gray-500 dark:text-gray-400">HW CRC</dt>
        <dd className="text-gray-900 dark:text-white">{targetInfo.hasHardwareCRC ? 'Yes' : 'No'}</dd>
      </dl>
    </div>
  );
};

export default TargetInfoView;
